import React from "react";

const Video = (props) => {
  return (
    <div className="bg-gray-100">
      <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="relative lg:grid lg:grid-cols-3 lg:gap-x-8 items-center">
          <div className=" sm:grid sm:grid-cols-1 sm:gap-x-8 sm:gap-y-10 lg:col-span-2  ">
            <div className="relative flex flex-col min-w-0 break-words  mb-4">
              <div className=" flex-auto">
                <div className="tab-content tab-space">
                  <iframe
                    src={`https://player.vimeo.com/video/${props.src}`}
                    frameBorder="0"
                    width="100%"
                    height="450"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    className="mx-auto max-w-screen-xl"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-1">
            <h3 className=" text-xl font-bold tracking-tight text-gray-900 ">
              {props.title}
            </h3>
            {props.image?.map((i) => (
              <>
                <img className="py-4 w-2/3" src={i.src} alt={i.alt} />
                <p>{i.alt}</p>
              </>
            ))}
            {props.description && 
            <p className="mt-2 text-base leading-6 text-gray-500">
            {props.description}
          </p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Video;
